import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { ModalComponent } from '../../layout/modals/ModalComponent';
import { FormField } from '../../layout/form-fields/FormField';
import { expertiseAreaStore } from './ExpertiseAreaStore';

const ValidationSchema = Yup.object().shape({
	name: Yup.string().required().label('Name')
});

export class ExpertiseAreaCreate extends ModalComponent {
	render() {
		return (
			<Formik
				initialValues={{
					name: ''
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.save(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'ExpertiseAreaCreate')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<div className="columns">
				<div className="column is-full">
					<FormField
						required
						className="has-text-left"
						label="Name"
						field="name"
						type="text"
						placeholder="Name"
					/>
				</div>
			</div>
		);
	}

	async save(values) {
		expertiseAreaStore
			.create({
				name: values.name
			})
			.then(result => {
				this.resultNotification(result, 'ExpertiseArea', 'Create');
			});
	}
}
